/**
 * Converts a Date to YYYY-MM-DD using local timezone components.
 * Avoids the CET/CEST off-by-one bug of toISOString().slice(0,10),
 * which converts to UTC before formatting.
 */
export function localIsoDate(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
